import { useState, useEffect } from 'react'
import { supabase } from '../api/supabase'

export interface Customer {
  id: string
  code: string
  name: string
  country?: string
  contact_email?: string
  contact_phone?: string
}

export function useCustomerSearch() {
  const [query, setQuery] = useState('')
  const [results, setResults] = useState<Customer[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (query.trim().length >= 2) {
      searchCustomers(query)
    } else {
      setResults([])
    }
  }, [query])

  const searchCustomers = async (searchQuery: string) => {
    try {
      setLoading(true)

      // Z88: Customer-role filter done in the query itself (inner join), not by fetching every
      // role id and pasting them into .in() -- that broke past ~1000 customers.
      const q = supabase
        .from('customers')
        .select('id, code, name, country, contact_email, contact_phone, customer_address_types!inner(address_types!inner(code))')
        .eq('is_active', true)
        .eq('customer_address_types.address_types.code', 'Cus')
        .or(`name.ilike.%${searchQuery}%,code.ilike.%${searchQuery}%`)
        .order('name')
        .limit(10)

      const { data, error } = await q
      if (error) throw error
      setResults((data || []).map(c => ({
        id: c.id, code: c.code, name: c.name, country: c.country,
        contact_email: c.contact_email, contact_phone: c.contact_phone,
      })) as Customer[])
    } catch (error) {
      console.error('Error searching customers:', error)
      setResults([])
    } finally {
      setLoading(false)
    }
  }

  return {
    query,
    setQuery,
    results,
    loading
  }
}
